import { Icon, Tappable, useTheme } from "@rally/ui-kit";
import { say } from "../../localization/say.ts";
import { COMPOSER_ROW } from "./composer-state.ts";

export function SendButton({
  ready,
  onPress,
  testID,
}: {
  ready: boolean;
  onPress: () => void;
  testID: string;
}) {
  const theme = useTheme();
  return (
    <Tappable
      onPress={onPress}
      disabled={!ready}
      accessibilityRole="button"
      accessibilityLabel={say("chat.send")}
      testID={testID}
      {...({ onMouseDown: (event: { preventDefault: () => void }) => event.preventDefault() } as object)}
      style={{
        width: COMPOSER_ROW,
        height: COMPOSER_ROW,
        borderRadius: 999,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: ready ? theme.color.accent : theme.color["bg.surfaceAlt"],
      }}
    >
      <Icon name="arrow-up" size={16} color={ready ? "text.onAccent" : "text.tertiary"} />
    </Tappable>
  );
}
